module.exports = __webpack_public_path__ + "img/vk.09c881c3.svg";